import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL  = 'https://unvzfprqkmxrifwodlec.supabase.co';
const SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVudnpmcHJxa214cmlmd29kbGVjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE5NjY2NjcsImV4cCI6MjA4NzU0MjY2N30.Lcpfcb058sIlbViD-hmKLCO59yPkb36wZPuSnhGszDI';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON);